import { sleep } from '@ipfabric/ui-components/utils/sleep';
import { useEffect, useReducer, useState } from 'react';
import type { FC } from 'react';

export const UpdateBatchingTestGallerySection: FC = () => {
  // Check whether update batching works with React 18,
  const [n, forceUpdate] = useReducer((x) => x + 1, 0);
  const [firstUpdate, setFirstUpdate] = useState(0);

  useEffect(() => {
    (async () => {
      // exit to async
      await sleep(1);
      forceUpdate();
      forceUpdate();
    })();
  }, []);
  // biome-ignore lint/correctness/useExhaustiveDependencies(firstUpdate): would cause infinite loop
  useEffect(() => {
    if (firstUpdate === 0 && n > 0) {
      setFirstUpdate(n);
    }
  }, [n]);

  // biome-ignore lint/suspicious/noConsole: intentional usage
  console.log('UpdateBatchingTestGallerySection render');

  return (
    <div>
      <p>Checking whether update batching works...</p>
      <p>
        If it works, you should see only <strong>two</strong> instead of three
        occurrences of <strong>UpdateBatchingTestGallerySection render</strong>{' '}
        in dev console + see programmatic check result below that the first
        update was batched with the second one.
      </p>
      {firstUpdate === 0 && <p>initializing...</p>}
      {firstUpdate === 1 && (
        <p className='text-red-600'>Async update batching does NOT work</p>
      )}
      {firstUpdate === 2 && (
        <p className='text-green-600'>Async update batching DOES work</p>
      )}
    </div>
  );
};
